module.exports = __webpack_public_path__ + "static/description-95c5e8019aa9dbbd448825e358f7f194.png";